export enum GymActivityType {
  Included = 0,
  Paid = 1
}
